import React from 'react';

import {
  UpdatePaymentInfoInput,
  useEditPaymentSectionQuery as useBaseEditPaymentSectionQuery,
  useUpdatePaymentInfoMutation as useBaseUpdatePaymentInfoMutation
} from 'generated/graphql';
import {
  validationUtil,
  refetchQueries
} from 'modules';
import * as yup from 'yup';



export const __formSchema = yup.object({
  cardNumber: validationUtil.cardNumberSchema.required('Credit Card Number is required'),
  expirationDate: validationUtil.nonEmptyStringSchema.required('Expiration date is required.'),
  cvv: validationUtil.cardVerificationValue.required('CVV is required'),
  country: yup.string().required('Country is required'),
  usState: yup.string().required('State is required.'),
  city: yup.string().required('City is required.'),
  address: yup.string().required('Address is required.'),
  zipCode: validationUtil.nonEmptyStringSchema.max(250).required('Zip code is required.')
}).required();

export type IFormData = yup.InferType<typeof __formSchema>;



export interface IData {
  id: string;
  country: string;
  usState: string;
  city: string;
  address: string;
  zipCode: string;
}

export function useEditPaymentSectionQuery() {
  const tuple = useBaseEditPaymentSectionQuery();

  const data = React.useMemo((): IData => {
    const paymentInfo = tuple.data?.loggedInUser?.paymentInfo;
    return {
      id: paymentInfo?.id ?? '',
      country: paymentInfo?.country ?? '',
      usState:paymentInfo?.usState ?? '',
      city: paymentInfo?.city ?? '',
      address: paymentInfo?.address ?? '',
      zipCode: paymentInfo?.zipCode ?? ''
    };
  }, [tuple]);

  return {
    ...tuple,
    data
  };
}



export function useUpdatePaymentInfoMutation() {
  const [fnRunMutation, updatePaymentInfoMutationTuple] = useBaseUpdatePaymentInfoMutation();

  const fnWrappedUpdatePaymentInfoMutation = async (args: UpdatePaymentInfoInput) =>
    fnRunMutation({
      variables: {
        input: {
          ...args
        }
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        refetchQueries.EditPaymentSection({})
      ]
    });

  return [
    fnWrappedUpdatePaymentInfoMutation,
    updatePaymentInfoMutationTuple
  ] as const;
}
